import { useEffect } from "react"
import { useDispatch, useSelector } from "react-redux"
import { useNavigate } from "react-router-dom"

import SegmentTracker from "../../../common/tracking"
import { selectToken, tokenReceived } from "../../users/reducer"
import { safeNextPath } from "./magicLoginRedirect"

export default function AirtableMagicLogin() {
  const location = window.location.href
  const url = new URL(location)
  const dispatch = useDispatch()
  const currentToken = useSelector(selectToken)
  const navigate = useNavigate()
  const newToken = url.searchParams.get("token")
  const nextPath = safeNextPath(url.searchParams.get("next"))

  useEffect(() => {
    dispatch(tokenReceived(newToken))
    SegmentTracker.markImpersonator()
  }, [dispatch, newToken])

  useEffect(() => {
    if (currentToken === newToken) {
      navigate(nextPath)
    }
  }, [navigate, currentToken, newToken, nextPath])
}
